import { VoiceSessionCloseReasonQuery } from '../api/interfaces';
import { nortadaLogger } from '../components/common/logger';

const voiceSessionCloseReasonQueryMapper = (reason: string): VoiceSessionCloseReasonQuery => {
  const translations: Record<string, VoiceSessionCloseReasonQuery> = {
    End: 'END',
    Abandon: 'ABANDON',
    Timeout: 'TIMEOUT',
    'Session in progress': 'NOT_CLOSED_YET'
  };

  return translations[reason] ?? nortadaLogger.critical(`${reason} is unsupported Voice session close reason query.`);
};

export default voiceSessionCloseReasonQueryMapper;
